import { Flex } from '@chakra-ui/react'
import { useState } from 'react'
import { FaInfoCircle } from 'react-icons/fa'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { ModalBase } from '../../../../../components/ModalBase'
import { iIndicador, iMesPeriodo } from '../../../gestao'
import { IndicadorChart } from '../../../gestao/components/IndicadorChart'
import { ModalCriterios } from '../../../gestao/components/ModalCriterios'
import { TabelaIndicadorMensal } from '../TabelaIndicadorMensal'

interface iModalGraficoIndicadorProps {
  isOpen: boolean
  onClose: () => void
  indicador: iIndicador
  meses: iMesPeriodo[]
}

export const ModalGraficoIndicador: React.FC<iModalGraficoIndicadorProps> = ({ isOpen, onClose, indicador, meses }): JSX.Element => {
  const [TipoGrafico, setTipoGrafico] = useState<'bar' | 'line'>('bar')
  const [MostrarTabela, setMostrarTabela] = useState(true)
  const [CriteriosAberto, setCriteriosAberto] = useState(false)

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} Titulo={indicador.nome} Width={'62rem'}>
      <Flex flexDir={'column'} px={'1.5rem'} pb={'1.5rem'} gap={'1rem'}>
        <Flex gap={'.5rem'} alignItems={'center'} flexWrap={'wrap'}>
          <ButtonCmp VarColor={'Azul'} small onClick={() => setTipoGrafico(t => t === 'bar' ? 'line' : 'bar')}>
            {TipoGrafico === 'bar' ? 'Ver em linha' : 'Ver em colunas'}
          </ButtonCmp>
          <ButtonCmp VarColor={'c6'} small onClick={() => setMostrarTabela(v => !v)}>
            {MostrarTabela ? 'Ocultar tabela' : 'Mostrar tabela'}
          </ButtonCmp>
          <ElementoTooltipCmp label={'Critérios'}>
            <FaInfoCircle cursor={'pointer'} color={'var(--Azul)'} size={20} onClick={() => setCriteriosAberto(true)} />
          </ElementoTooltipCmp>
        </Flex>

        <IndicadorChart
          id={`modal-${indicador.id}`}
          data={meses}
          indicador={indicador}
          tipo={TipoGrafico}
          mostrarPercentual
        />

        {MostrarTabela && (
          <TabelaIndicadorMensal indicador={indicador} meses={meses} />
        )}
      </Flex>

      {CriteriosAberto && (
        <ModalCriterios
          isOpen={CriteriosAberto}
          onRequestClose={() => setCriteriosAberto(false)}
          somenteLeitura
          id={indicador.id}
          criterios={indicador.criterios}
          tipoMeta={indicador.tipoMeta}
          medidaMeta={indicador.medidaMeta}
          onConfirm={() => {}}
        />
      )}
    </ModalBase>
  )
}
